import { render, staticRenderFns } from "./PageBreak.vue?vue&type=template&id=41c12711&scoped=true"
import script from "./PageBreak.vue?vue&type=script&lang=js"
export * from "./PageBreak.vue?vue&type=script&lang=js"
import style0 from "./PageBreak.vue?vue&type=style&index=0&id=41c12711&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41c12711",
  null
  
)

export default component.exports